// extracted by mini-css-extract-plugin
export var shake = "_e-1";
export var toastCloseButton = "_e-0";